+function ($) {
    'use strict';

    if($("[name='commodityEditor']").length > 0) {
        var editor = CKEDITOR.replace('commodityEditor', {
            extraPlugins: 'uploadimage,image2',
            height: 300,
            image_previewText: ' ',
            filebrowserUploadUrl: '/admin/ckeditor/files',
            filebrowserImageUploadUrl: '/admin/ckeditor/files',
            stylesSet: [
                {name: 'Narrow image', type: 'widget', widget: 'image', attributes: {'class': 'image-narrow'}},
                {name: 'Wide image', type: 'widget', widget: 'image', attributes: {'class': 'image-wide'}}
            ],
            onUploaded: function (file, data, response) {
            }
        });
        var initValue = $("#editValue").val();
        if(initValue) {
            editor.setData(initValue);
        }
        editor.on( 'change', function( event ) {
            var data = this.getData();//内容
            $("#editValue").val(data)
        });
    }

    $(".round-tags").tagsinput({});

    if($("#shapeFlag").val() == "CYLINDER") {
        $("#squareOption").hide();
        $("#cylinderOption").show();
    } else {
        $("#squareOption").show();
        $("#cylinderOption").hide();
    }

    $(".commodity-add .shape-radio").on('change', function () {
        $("#squareOption").toggle();
        $("#cylinderOption").toggle();
    });

    $(".name-input").on('change blur keyup input', function (e) {
        var len = $(this).val().length;
        var count = $('#nameCount');
        count.text(len);
        if (len === 20) {
            count.addClass("text-warning")
        }
    })

    $(".description-input").on('change blur keyup input', function (e) {
        var len = $(this).val().length;
        var count = $('#descriptionCount');
        count.text(len);
        if (len === 20) {
            count.addClass("text-warning")
        }
    })

    $(".commodity-add-conform").on('click', function (e) {
        shapeOption();
        var price = $("input[name='semiSide.price']").val();
        var marketPrice = $("input[name='semiSide.marketPrice']").val();
        $("#defaultNowSelling").val(false);
        $("input[name='roughSide.price']").val(price);
        $("input[name='roughSide.marketPrice']").val(marketPrice);
        $("input[name='concentrateSide.price']").val(price);
        $("input[name='concentrateSide.marketPrice']").val(marketPrice);
        $('#commodityAddForm').submit()
    });

    $(".commodity-onshelf-conform").on('click', function (e) {
        shapeOption();
        $("#defaultNowSelling").val(true);
        $('#commodityAddForm').submit()
    });

    function shapeOption() {
        if($("#squareOption").css("display")=="none") {
            $("#squareOption").remove()
        } else {
            $("#cylinderOption").remove()
        }
    }

    $(".add-label").on('click', function (e) {
        $(".note-error").text('');
    });

    $("#addLabel .conform").on('click', function (e) {
        var form = $("#addLabel");
        form.validator('validate');
        if(!form.validator().data('bs.validator').hasErrors()){
            $.ajax({
                url: '/admin/commodityLabels/add',
                type: 'post',
                data: form.serialize(),
                success: function (res) {
                    if(res.name) {
                        var value = res.id.toString()+'`'+res.name;
                        $("#commodityLabelChosen").append($("<option key='"+res.id+"' value='"+value+"'>"+res.name+"</option>"));
                        $("#commodityLabelChosen").selectpicker("refresh");
                    }
                    $("#addLabelModal").modal("hide");
                    form[0].reset()
                },
                error: function (res) {
                    if (res.status == 401) {
                        $(".note-error").text('('+res.responseText+')');
                    } else {
                        $("#addLabelModal").modal("hide");
                    }
                }
            });
        }

    })

    $("#addSteelType .conform").on('click', function (e) {
        var form = $("#addSteelType");
        form.validator('validate');
        if(!form.validator().data('bs.validator').hasErrors()){
            $.ajax({
                url: '/admin/steelTypes/add',
                type: 'post',
                data: form.serialize(),
                success: function (res) {
                    if (res.name) {
                        $("#commodityTypeChosen").append($("<option key='" + res.id + "' value='" + res.id + "'>" + res.name + ' | 密度：' + res.density + ' kg/mm³' + "</option>"));
                        $("#commodityTypeChosen").selectpicker("refresh");
                    }
                    $("#addTypeModal").modal("hide");
                    form[0].reset()
                },
                error: function (res) {
                    $("#addTypeModal").modal("hide");
                }
            });
        }
    })

}(jQuery);
